import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Box, Grid, Stack } from "@mui/system";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect, useMemo, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableSortLabel } from "@mui/material";
import GoogleAds from "./ConversionsUploadedGraphs/GoogleAds";
import BingAds from "./ConversionsUploadedGraphs/BingAds";
import MetaAds from "./ConversionsUploadedGraphs/MetaAds";
import IncentivezedTraffic from "./ConversionsUploadedGraphs/IncentivezedTraffic";
import { useSearchParams } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import FilterLateConversion from "../LoadedAccordionsFilter/FilterLoadedAccordions";
import AllAdsBarChart from "./ConversionsUploadedGraphs/CombineBarchart";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";

interface Props {
  uploadedToPlatformsData: any[];
  advertisingPlatformsData: any[];
  selecteDate: any;
}

const ConversionsUploadComparison = ({
  uploadedToPlatformsData,
  advertisingPlatformsData,
  selecteDate,
}: Props) => {
  const [clickedTraffic, setClickedTraffic] = useState();

  const tableHeadings = {
    keyword_id: "Keyword ID",
    user_unique_id: "User Unique ID",
    ad_platform_click_id: "AD Platform Click ID",
    click_date: "Click Date",
    conversion_date: "Conversion Date",
    brand_id: "Brand ID",
    brand_name: "Brand Name",
    ad_platform_account_id: "Ad Platform Account ID",
    keyword_name: "Keyword Name",
    matchtype: "Match Type",
    traffic_source: "Traffic Source",
    adgroup_name: "Ad Group Name",
    adgroup_id: "Ad Group ID",
    campaign_name: "Campaign Name",
    campaign_id: "Campaign ID",
    ad_platform_account_name: "Ad Account Name",
  };

  // const totalUploaded = uploadedToPlatformsData?.length;
  // const totaleported = advertisingPlatformsData?.length;
  const groupedByTrafficSource = uploadedToPlatformsData?.reduce(
    (groups, trafficSource) => {
      const ts = trafficSource.traffic_source;
      if (!groups[ts]) {
        groups[ts] = [];
      }
      groups[ts].push(trafficSource);
      return groups;
    },
    {}
  );

  const isTrafficSourceExistReported = (trafficSource: string) => {
    return Object.keys(groupedByTrafficSource)?.includes(trafficSource);
  };

  const isTrafficSourceExistAppearing = (trafficSource: string) => {
    const source = advertisingPlatformsData?.filter(
      (item: any) => item?.traffic_source === trafficSource
    );

    if (source) {
      return Math.round(source[0]?.conversions_uploaded as any);
    }

    return null;
  };

  const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const [searchKeyWord, SetSearchKeyWord] = useState("");

  const [sortField, setSortField] = useState("keyword_id") as any;
  const [sortOrder, setSortOrder] = useState("asc") as any;

  const [searchParams, setSearchParams] = useSearchParams();

  const searchOptions = uploadedToPlatformsData?.reduce(
    (acc: Record<string, any[]>, site: any) => {
      const key = site?.keyword_name; // group key
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(site); // push the full object
      return acc;
    },
    {}
  ) as any;

  //filters state
  const [selectedTrafficSource, setSelectedTrafficSource] = useState([]) as any;
  const [selectedMatchType, setSelectedMatchType] = useState([]) as any;
  const [selectedCampaign, setSelectedCampaign] = useState([]) as any;
  const [selectedAdGroup, setSelectedAdGroup] = useState([]) as any;

  const handleChange =
    (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const headCells = Object.entries(tableHeadings);

  // Function to handle header clicks
  const handleSortClick = (field: any) => {
    if (sortField === field) {
      // Toggle order if same column
      setSortOrder((prev: any) => (prev === "asc" ? "desc" : "asc"));
    } else {
      // Set new column & reset order to asc
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const filteredAndSortedData = useMemo(() => {
    if (uploadedToPlatformsData?.length > 0) {
      let result = [...uploadedToPlatformsData];

      // Filter by Traffic Source
      if (selectedTrafficSource?.length > 0) {
        result = result.filter((item) =>
          selectedTrafficSource?.includes(item?.traffic_source)
        );
      }

      // Filter by MatchType
      if (selectedMatchType?.length > 0) {
        result = result?.filter((item: any) =>
          selectedMatchType?.includes(item?.matchtype)
        );
      }

      // Filter by Campaign
      if (selectedCampaign?.length > 0) {
        result = result?.filter((item) =>
          selectedCampaign?.includes(item?.campaign_name)
        );
      }

      // Filter by AdGroup
      if (selectedAdGroup?.length > 0) {
        result = result?.filter((item) =>
          selectedAdGroup?.includes(item?.adgroup_name)
        );
      }

      if (searchKeyWord?.length > 0) {
        result = result?.filter((item) => item?.keyword_name === searchKeyWord);
      }

      // Sort
      result?.sort((a, b) => {
        if (a[sortField] < b[sortField]) return sortOrder === "asc" ? -1 : 1;
        if (a[sortField] > b[sortField]) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });

      return result;
    } else {
      return [];
    }
  }, [
    selectedTrafficSource,
    selectedMatchType,
    selectedCampaign,
    selectedAdGroup,
    sortField,
    sortOrder,
    uploadedToPlatformsData,
    searchKeyWord,
  ]);

  const handelSelectedKeyWord = (_: any, newValue: any) => {
    SetSearchKeyWord(newValue);
  };

  useEffect(() => {
    const updatedSearchParams = new URLSearchParams(searchParams);
    updatedSearchParams.delete("filters");
    // Update the URL
    setSearchParams(updatedSearchParams);
    // eslint-disable-next-line
  }, [
    selectedTrafficSource,
    selectedMatchType,
    selectedCampaign,
    selectedAdGroup,
  ]);

  useEffect(() => {
    if (selecteDate) {
      setSelectedTrafficSource([]);
      setSelectedMatchType([]);
      setSelectedCampaign([]);
      setSelectedAdGroup([]);
      SetSearchKeyWord("");
    }
  }, [selecteDate]);

  useEffect(() => {
    if (clickedTraffic) {
      setSelectedTrafficSource(clickedTraffic);
    }
  }, [clickedTraffic]);

  return (
    <>
      <Grid container spacing={2} alignItems={"center"}>
        <Box sx={{ padding: "16px !important" }}>
          <Grid size={12}>
            <Typography variant="h5">Reported vs. Ad Platforms</Typography>
          </Grid>
          <Grid mb={4}>
            <Stack direction={"row"} gap={4}>
              <AllAdsBarChart
                uploadedToPlatformsData={uploadedToPlatformsData}
                advertisingPlatformsData={advertisingPlatformsData}
                setClickedTraffic={setClickedTraffic}
              />
              {uploadedToPlatformsData?.length > 0 &&
              advertisingPlatformsData?.length > 0 ? (
                <Stack flexDirection={"row"} gap={4} sx={{ width: "100%" }}>
                  {/* <Card sx={{ padding: "16px", width: "100%" }}>
                <Typography variant="subtitle2" color="secondary" mb={1}>
                  Conversions reported
                </Typography>
                {Object.values(groupedByTrafficSource)?.length > 0 ? (
                  <ConversionsReportedPieChart
                    setClickedTraffic={setClickedTraffic}
                    totalLoaded={totalUploaded}
                    selectedActionType={selectedActionType}
                    groupedByTrafficSource={groupedByTrafficSource}
                  />
                ) : (
                  <Alert
                    sx={{ color: "#ED6C02", mb: 1 }}
                    severity="warning"
                    icon={
                      <InfoOutlinedIcon fontSize="inherit" sx={{ mr: 1 }} />
                    }
                  >
                    NO DATA FOR Conversions uploaded to platforms
                  </Alert>
                )}
              </Card> */}
                  {/* <Card sx={{ padding: "16px", width: "100%" }}>
                <Typography variant="subtitle2" color="secondary" mb={1}>
                  Conversions appearing on ad platforms
                </Typography>
                {advertisingPlatformsData?.length > 1 ? (
                  <ConversionsReportedPieChart
                    setClickedTraffic={setClickedTraffic}
                    totalLoaded={totaleported}
                    selectedActionType={selectedActionType}
                    groupedByTrafficSource={""}
                    advertisingPlatformsData={advertisingPlatformsData}
                  />
                ) : (
                  <Alert
                    sx={{ color: "#ED6C02", mb: 1 }}
                    severity="warning"
                    icon={
                      <InfoOutlinedIcon fontSize="inherit" sx={{ mr: 1 }} />
                    }
                  >
                    NO DATA FOR Conversions uploaded to platforms
                  </Alert>
                )}
              </Card> */}
                  {/* Gap in Google Ads */}
                  <Box sx={{ width: "100%" }}>
                    {isTrafficSourceExistReported("g_ads_search") &&
                    isTrafficSourceExistAppearing("g_ads_search") ? (
                      <GoogleAds
                        reported={
                          groupedByTrafficSource["g_ads_search"]?.length
                        }
                        appear={isTrafficSourceExistAppearing("g_ads_search")}
                      />
                    ) : (
                      <Box
                        width="100%"
                        p={1}
                        border="1px solid #E0E0E0"
                        borderRadius="8px"
                        minHeight={105}
                      >
                        <Stack direction="row" justifyContent="space-between">
                          <Typography
                            variant="subtitle2"
                            color="text.secondary"
                            mb={1}
                            fontSize="16px"
                          >
                            Gap in Google Ads
                          </Typography>
                          <img
                            src="/GoogleAds.png"
                            alt="Meta Ads"
                            width={24}
                            height={24}
                            style={{ objectFit: "contain" }}
                          />
                        </Stack>
                        <Typography
                          variant="body2"
                          mt={1}
                          color="text.secondary"
                        >
                          {" "}
                          NO DATA FOR Bing Ads
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  {/* Gap in Bing Ads */}
                  <Box sx={{ width: "100%" }}>
                    {isTrafficSourceExistReported("bing_ads_search") &&
                    isTrafficSourceExistAppearing("bing_ads_search") ? (
                      <BingAds
                        reported={
                          groupedByTrafficSource["bing_ads_search"]?.length
                        }
                        appear={isTrafficSourceExistAppearing(
                          "bing_ads_search"
                        )}
                      />
                    ) : (
                      <Box
                        width="100%"
                        p={1}
                        border="1px solid #E0E0E0"
                        borderRadius="8px"
                        minHeight={119}
                      >
                        <Stack direction="row" justifyContent="space-between">
                          <Typography
                            variant="subtitle2"
                            color="text.secondary"
                            mb={1}
                            fontSize="16px"
                          >
                            Gap in Bing Ads
                          </Typography>
                          <img
                            src="/bing.png"
                            alt="Meta Ads"
                            width={24}
                            height={24}
                            style={{ objectFit: "contain" }}
                          />
                        </Stack>
                        <Typography
                          variant="body2"
                          mt={1}
                          color="text.secondary"
                        >
                          {" "}
                          NO DATA FOR Bing Ads
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  {/* Gap in Meta Ads */}
                  <Box sx={{ width: "100%" }}>
                    {isTrafficSourceExistReported("meta_ads") &&
                    isTrafficSourceExistAppearing("meta_ads") ? (
                      <MetaAds
                        reported={groupedByTrafficSource["meta_ads"]?.length}
                        appear={
                          isTrafficSourceExistAppearing("meta_ads") as number
                        }
                      />
                    ) : (
                      <Box
                        width="100%"
                        p={1}
                        border="1px solid #E0E0E0"
                        borderRadius="8px"
                        minHeight={105}
                      >
                        <Stack direction="row" justifyContent="space-between">
                          <Typography
                            variant="subtitle2"
                            color="text.secondary"
                            mb={1}
                            fontSize="16px"
                          >
                            Gap in Meta Ads
                          </Typography>
                          <img
                            src="/meta.png"
                            alt="Meta Ads"
                            width={36}
                            height={24}
                            style={{ objectFit: "contain" }}
                          />
                        </Stack>
                        <Typography
                          variant="body2"
                          mt={1}
                          color="text.secondary"
                        >
                          {" "}
                          NO DATA FOR Meta Ads
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  {/* Gap in Incentivized Traffic */}
                  <Box sx={{ width: "100%" }}>
                    {isTrafficSourceExistReported("incentivezed_traffic") &&
                    isTrafficSourceExistAppearing("incentivezed_traffic") ? (
                      <IncentivezedTraffic
                        reported={
                          groupedByTrafficSource["incentivezed_traffic"]?.length
                        }
                        appear={isTrafficSourceExistAppearing(
                          "incentivezed_traffic"
                        )}
                      />
                    ) : (
                      <Box
                        width="100%"
                        p={1}
                        border="1px solid #E0E0E0"
                        borderRadius="8px"
                        minHeight={105}
                      >
                        <Stack direction="row" justifyContent="space-between">
                          <Typography
                            variant="subtitle2"
                            color="text.secondary"
                            mb={1}
                            fontSize="16px"
                          >
                            Gap in Meta Ads
                          </Typography>
                          <RequestQuoteIcon />
                        </Stack>
                        <Stack>
                          <Typography
                            variant="body2"
                            mt={1}
                            color="text.secondary"
                          >
                            {" "}
                            NO DATA FOR Incentivezed Ads
                          </Typography>
                        </Stack>
                      </Box>
                    )}
                  </Box>
                </Stack>
              ) : (
                ""
              )}
            </Stack>
          </Grid>
        </Box>
        <Grid size={12}>
          {filteredAndSortedData?.length > 0 ? (
            <Accordion
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
              sx={{ margin: "0 !important" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  component="span"
                  sx={{
                    width: "33%",
                    flexShrink: 0,
                    fontSize: "24px !important",
                    fontWeight: 400,
                  }}
                >
                  Detailed Player level
                  {/* <Typography fontSize={14} fontWeight={400} color="text.secondary">
              Failed due to this reason:{" "}
              {rows?.length > 0 ? getCalculatedRows() : 0}{" "}
              {`(${percentage}% of ${total} FTD’s)`}
            </Typography> */}
                </Typography>
                <Typography
                  component="span"
                  sx={{
                    color: "text.secondary",
                    fontSize: 12,
                    width: "50%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  See the full list of players Who were reported but do not
                  appear on the ad platform.
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid size={3}>
                    <Autocomplete
                      value={searchKeyWord}
                      onChange={handelSelectedKeyWord}
                      sx={{ width: "100%" }}
                      options={Object.keys(searchOptions)}
                      getOptionLabel={(option: any) => option}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selected Key Word"
                          color="secondary"
                          size="small"
                          InputProps={{
                            ...params.InputProps,
                            readOnly: true,
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon sx={{ marginLeft: "12px" }} />
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid size={9}>
                    <FilterLateConversion
                      data={uploadedToPlatformsData}
                      setSelectedAdGroup={setSelectedAdGroup}
                      setSelectedCampaign={setSelectedCampaign}
                      setSelectedMatchType={setSelectedMatchType}
                      setSelectedTrafficSource={setSelectedTrafficSource}
                      selectedTrafficSource={selectedTrafficSource}
                      selectedMatchType={selectedMatchType}
                      selectedCampaign={selectedCampaign}
                      selectedAdGroup={selectedAdGroup}
                    />
                  </Grid>
                </Grid>
                <TableContainer
                  className="PageScantablewrap"
                  sx={{ maxHeight: 588 }}
                >
                  {uploadedToPlatformsData?.length > 0 ? (
                    <Table
                      aria-label="collapsible table"
                      size="small"
                      stickyHeader
                    >
                      <TableHead>
                        <TableRow>
                          {headCells?.map(([key, value], index) => (
                            <TableCell key={index} align="left">
                              <TableSortLabel
                                active={sortField === key}
                                direction={
                                  sortField === key ? sortOrder : "asc"
                                }
                                onClick={() => handleSortClick(key)}
                              >
                                {value}
                              </TableSortLabel>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredAndSortedData?.map((row, rowIndex) => (
                          <React.Fragment key={rowIndex}>
                            <TableRow
                              sx={{
                                "& > *": {
                                  borderBottom:
                                    "1px solid rgba(224, 224, 224, 1) !important",
                                },
                              }}
                            >
                              {headCells.map(([key], cellIndex) => (
                                <TableCell key={cellIndex} align="left">
                                  {key === "keyword_id" ? (
                                    <>{row[key] ? row[key] : "N/A"}</>
                                  ) : key === "user_unique_id" ? (
                                    <> {row[key] ? row[key] : "N/A"}</>
                                  ) : key === "ad_platform_click_id" ? (
                                    <> {row[key] ? row[key] : "N/A"}</>
                                  ) : key === "click_date" ? (
                                    <> {row[key] ? row[key] : "N/A"}</>
                                  ) : key === "conversion_date" ? (
                                    <> {row[key] ? row[key] : "N/A"}</>
                                  ) : key === "brand_id" ? (
                                    <> {row[key] ? row[key] : "N/A"}</>
                                  ) : key === "brand_name" ? (
                                    <> {row[key] ? row[key] : "N/A"}</>
                                  ) : key === "ad_platform_account_id" ? (
                                    <> {row[key] ? row[key] : "N/A"}</>
                                  ) : key === "keyword_name" ? (
                                    <> {row[key] ? row[key] : "N/A"}</>
                                  ) : key === "matchtype" ? (
                                    <> {row[key] ? row[key] : "N/A"}</>
                                  ) : key === "traffic_source" ? (
                                    <>{row[key] ? row[key] : "N/A"}</>
                                  ) : key === "adgroup_name" ? (
                                    <>{row[key] ? row[key] : "N/A"}</>
                                  ) : key === "adgroup_id" ? (
                                    <>{row[key] ? row[key] : "N/A"}</>
                                  ) : key === "campaign_name" ? (
                                    <>{row[key] ? row[key] : "N/A"}</>
                                  ) : key === "campaign_id" ? (
                                    <>{row[key] ? row[key] : "N/A"}</>
                                  ) : key === "ad_platform_account_name" ? (
                                    <>{row[key] ? row[key] : "N/A"}</>
                                  ) : row[key] ? (
                                    row[key]
                                  ) : (
                                    "N/A"
                                  )}
                                </TableCell>
                              ))}
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  ) : (
                    ""
                  )}
                </TableContainer>
              </AccordionDetails>
            </Accordion>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100px", // gives some vertical space
                width: "100%",
              }}
            >
              <Typography fontSize={20} fontWeight={500} color="text.secondary">
                NO DATA FOR Gap in Brand Data
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ConversionsUploadComparison;
